export const colorMap = {
    SUCCESS: 'success',
    WARNING: 'warning',
    INSUFFICIENT_DATA: 'secondary',
    FAILURE: 'error',
};
